var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconBullhorn = function SvgElIconBullhorn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el-icon-bullhorn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.871 10.568v4.785c0 .907.743 1.567 1.568 1.567.825 0 1.567-.742 1.567-1.567v-4.62l7.013 1.897c.247.825 1.072 1.32 1.98 1.073.66-.165 1.155-.825 1.155-1.568V2.648c0-.908-.743-1.568-1.568-1.568-.742 0-1.32.495-1.567 1.155l-7.59 1.98H4.87c-1.815 0-3.217 1.403-3.217 3.218s1.402 3.135 3.217 3.135Zm2.145 4.785c0 .33-.247.495-.495.495-.247 0-.495-.248-.495-.495v-4.785H7.1v4.785h-.083Zm9.57-13.283c.33 0 .495.248.495.495v9.57c0 .33-.247.495-.495.495-.33 0-.495-.247-.495-.495V2.648c-.082-.33.165-.578.495-.578Zm-1.65 9.405L8.006 9.66V5.123l6.93-1.815v8.167ZM4.871 5.288h2.145v4.29H4.871c-1.155 0-2.145-.99-2.145-2.145a2.13 2.13 0 0 1 2.145-2.145Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "el-icon-bullhorn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.904 0h18v18h-18z"
  })))));
};
export default SvgElIconBullhorn;